import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8.5",
      cy: "8",
      r: "8",
      fill: "#828282",
      "fill-opacity": "0.75"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.41949 6.07094V12.4446H7.71711V6.07094H9.41949ZM7.61108 4.4098C7.61108 4.16239 7.69748 3.95819 7.87027 3.79718C8.04306 3.63617 8.27476 3.55566 8.56536 3.55566C8.85203 3.55566 9.08177 3.63617 9.25456 3.79718C9.43127 3.95819 9.51963 4.16239 9.51963 4.4098C9.51963 4.6572 9.43127 4.86141 9.25456 5.02242C9.08177 5.18343 8.85203 5.26393 8.56536 5.26393C8.27476 5.26393 8.04306 5.18343 7.87027 5.02242C7.69748 4.86141 7.61108 4.6572 7.61108 4.4098Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }